import type {
  ConnectChildData,
  ConnectChildPayload,
  DisconnectChildData,
  DisconnectChildPayload,
  GetParentByParentIdData,
} from '~/api-spec/__generated__/main'
import { httpClient, type RequestMeta } from '~/http/client'

import { adaptParentChildren } from './adapters'
import type { ParentChildren, ParentId } from './schemas'

/** 학부모 계정에 연결된 자녀들 */
export const getParentChildren = async (
  parentId: ParentId,
  meta?: RequestMeta,
): Promise<ParentChildren> => {
  const body = await httpClient().get<GetParentByParentIdData>(`/parents/${parentId}`, { meta })
  return adaptParentChildren(body.data)
}
// 학생 id 목록을 받는다. Student 엔티티가 학부모 스키마를 품어 여기서 Student 를 참조하면 순환이 생기므로
// 생성 타입(학생 id 문자열 배열)을 그대로 받는다.

/** 형제 학생들을 한 학부모 계정으로 묶는다 */
export const connectSiblings = async (
  studentIds: ConnectChildPayload,
  meta?: RequestMeta,
): Promise<void> => {
  await httpClient().post<ConnectChildData>('/parent-relations', studentIds, { meta })
}

/** 학생들을 형제 묶음에서 뺀다 */
export const disconnectSiblings = async (
  studentIds: DisconnectChildPayload,
  meta?: RequestMeta,
): Promise<void> => {
  await httpClient().delete<DisconnectChildData>('/parent-relations', { data: studentIds, meta })
}
